import { fetchServices, fetchRebook, assignSer } from '@/api/service'
const getFlightNextDay = (context) => {
  fetchServices().then((response) => {
    context.commit(
      'FLIGHTNEXTDAY_UPDATED',
      _.find(response, function (o) {
        return o.service_id == 2
      })
    )
  })
}

const getRebook = (context) => {
  fetchRebook().then((response) => {
    context.commit('REBOOK_UPDATED', response)
  })
}

const assignService = (context, payload) => {
  return assignSer(payload).then((response) => {
    return response
  })
}

export default {
  getFlightNextDay,
  getRebook,
  assignService
}
